/**
 * React builds must not keep the legacy `/sw.js` worker.
 * That worker precaches legacy `/assets/app.js` paths and, on fetch
 * failure, returns `Response.error()` — which surfaces as
 * `net::ERR_FAILED` for Vite-hashed `/assets/index-*.js` on reload.
 */
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.getRegistrations().then((registrations) =>
    Promise.all(registrations.map((registration) => registration.unregister()))
  ).catch(() => {});
}
